var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"sidebar"},[_c('div',{staticClass:"sidebar__fixed"},[_vm._t("sidebar-content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }